module.exports = __webpack_public_path__ + "static/media/lue_1.306884cc.jpg";